import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './styles/App.css';
import LoginPage from './components/LoginPage';
import MainPage from './components/MainPage';
import UsersService from './service/UsersService';
import UsersTab from './components/UsersTab';
import UserDetails from './components/UserDetails';

export default function BackOfficeApp() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState('');

  useEffect(() => {
    const savedUser = localStorage.getItem('currentUser');

    if (savedUser) {
      setCurrentUser(savedUser);
      setIsLoggedIn(true);
    }

    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'he';
  }, []);

  const handleLogin = (username) => {
    setCurrentUser(username);
    setIsLoggedIn(true);
    localStorage.setItem('currentUser', username);
  };

  const handleLogout = () => {
    UsersService.clear();
    setIsLoggedIn(false);
    setCurrentUser('');
    sessionStorage.clear();
    localStorage.clear();
  };

  return (
    <BrowserRouter>
      <Routes>

        {/* Login */}
        <Route
          path="/login"
          element={
            isLoggedIn
              ? <Navigate to="/" />
              : <LoginPage onLogin={handleLogin} />
          }
        />

        {/* App */}
        <Route
          path="/*"
          element={
            isLoggedIn
              ? <MainPage currentUser={currentUser} onLogout={handleLogout} />
              : <Navigate to="/login" />
          }
        />
        <Route path="/users" element={<UsersTab />} />
        <Route path="/users/:id" element={<UserDetails />} />
      </Routes>
    </BrowserRouter>
  );
}